// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xF0v","selected":"styles_selected__G1fHk"};